import {log} from './BannerCommon';

declare global {
    interface Window {
        execScript?: (s: string) => void;
    }
}

export class JSEvaluator {
    static JSPLACE_ATTR_NAME = "jsplace";

    static findNearestPlace(from: HTMLElement, depth: number): (string|null) {
        while (from !== null && depth > 0) {
            const jsplace = from.getAttribute(JSEvaluator.JSPLACE_ATTR_NAME);
            if (jsplace) {
                return jsplace;
            }
            from = from.parentElement!;
            depth--;
        }
        return null;
    }

    static evalScript(text: string) {
        text.replace(/(^[^<]*<!--)|(-->[^>]*$)/g, "");
        if (!text) {
            // execScript throws an exception if it's argument is empty string
            return;
        }
        if (window.execScript) {
            // для IE
            window.execScript(text);
        // eslint-disable-next-line no-eval
        } else if (window.eval) {
            // для мозилы
            // eslint-disable-next-line no-eval
            window.eval(text);
        } else {
            // eslint-disable-next-line no-eval
            eval(text);
        }
    }

    findAndEvalScripts(element: HTMLElement) {
        const nodeList = element.getElementsByTagName("script");
        if (!nodeList.length) {
            return;
        }

        // копируем потому что список мутируется при изменении DOM
        const scripts: HTMLScriptElement[] = [].slice.call(nodeList, 0);

        scripts.forEach(item => {
            const src = item.getAttribute("src");
            if (src !== null && src.trim()) {
                const parent = item.parentNode!;
                parent.removeChild(item);

                const scrElem = document.createElement("script");
                scrElem.src = src;
                scrElem.type = "text/javascript";

                const onloadScript = item.getAttribute("onload");
                if (onloadScript !== null) {
                    this.addOnloadScript(scrElem, onloadScript);
                }

                parent.appendChild(scrElem);
            } else {
                const text = item.innerHTML;
                this.evalInlineJS(item, text);
            }
        });
    }

    evalInlineJS(context: HTMLScriptElement, script: string) {
        if (script) {
            try {
                JSEvaluator.evalScript(script);
            } catch (ex) {
                this.logError(context, ex as Error);
            }
        }
    }

    logError(script: HTMLScriptElement, ex: Error) {
        log('Error of script evaluating: ', script, '; error: ', ex);
    }

    addOnloadScript(scrEl: HTMLScriptElement, scrTxt: string) {
        scrEl.onload = () => {
            this.evalInlineJS(scrEl, scrTxt);
        };
    }
}
